import { combineReducers } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';
import prePostReducer from './prePostReducer';


const reducers = combineReducers({
  form: formReducer,
  prePost: prePostReducer,
});

export default reducers;
